// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jNhB5","label":"styles_label__boMz9"};